import { MEDIA_QUERIES } from "@constants"
import styled, { keyframes } from "styled-components"

const ImageKeyframes = keyframes`
  from {
    translate: 0 0;
    opacity: 1;
  }

  to {
    translate: 0 -10%;
    opacity: 0;
  }
`

export const PostBookHeroHERO = styled.div`
  padding: var(--PostBookHero--padding-top) 0 var(--spacing--L);
  position: relative;
  overflow: hidden;
  z-index: 1;

  .ImageAboveFold {
    aspect-ratio: 16/9;
    max-width: var(--PostBookHero--image-max-width);
    max-height: var(--PostBookHero--image-max-height);
    position: absolute !important;
    right: 0;
    top: 0;
    z-index: 0;

    &::before,
    &::after {
      background-color: var(--PostBook--background);
      content: "";
      display: block;
      left: 0;
      position: absolute;
      transition: background-color var(--PostBook--theme-transition-length);
      z-index: 1;
    }

    &::before {
      height: 100%;
      mask-image: linear-gradient(to right, black, rgba(0, 0, 0, 0));
      top: 0;
      width: 33.3333%;
    }

    &::after {
      bottom: 0;
      height: 60%;
      mask-image: linear-gradient(to top, black, rgba(0, 0, 0, 0));
      width: 100%;
    }

    @supports ((animation-timeline: scroll()) and (animation-range: 0% 100%)) {
      animation: ${ImageKeyframes} linear both;
      animation-timeline: scroll(root);
      animation-range: 0% calc(var(--PostBookHero--padding-top) * 1.5);
    }
  }

  .container {
    position: relative;
    z-index: 1;
  }

  .PostBookHero--breadcrumbs {
    display: none;
    align-items: center;
    margin-bottom: var(--spacing--S);

    ${MEDIA_QUERIES.M} {
      display: flex;
    }

    a,
    .Icon {
      opacity: 0.6;
    }

    a {
      color: var(--PostBook--text-color);
      transition: opacity 0.3s;

      &:hover {
        opacity: 1;
      }
    }
    
    .current {
      opacity: 1;
    }
  }

  h1 {
    color: var(--PostBook--headlines-color);
    margin-bottom: var(--spacing--S);
    max-width: 21ch;
    text-wrap: balance;
  }

  p {
    color: var(--PostBook--text-color);
  }

  .PostBookHero--authors {
    align-items: center;
    color: var(--PostBook--text-color);
    display: flex;
    gap: var(--spacing--base-0-5);
    max-width: var(--text-max-width);

    .AvatarsRow {
      margin-right: var(--spacing--base-0-25);
    }

    .Avatar {
      box-shadow: 0 0 0 2px var(--PostBook--background);
      border-radius: 50%;
    }

    span {
      margin: 0;
    }
  }

  .PostBookHero--introduction {
    max-width: var(--text-max-width);
    margin: 0;

    .Content * {
      font-size: var(--font-size--2XL);
      font-weight: var(--font-weight--light);
    }
  }
`
